function createCookie(name,value,s) {

  if (s) {

    var date = new Date();

    date.setMonth(date.getMonth()+s)

    var expires = "; expires="+date.toGMTString();

  }

  else var expires = "";

  document.cookie = name+"="+value+expires+"; path=/";

}

function eraseCookie(name) {

  createCookie(name,"",-1);

}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


var cookieLight = getCookie('lightCook');
if (cookieLight === 'null'
    || cookieLight === ""
    || cookieLight === null
    || cookieLight === undefined
    || cookieLight === 'undefined') {
  $("body").removeClass("light");
}
else {
  $("body").addClass("light");
}

var cookieDark = getCookie('darkCook');
if (cookieDark === 'null'
    || cookieDark === ""
    || cookieDark === null
    || cookieDark === undefined
    || cookieDark === 'undefined') {
  $("body").removeClass("dark");
}
else {
  $("body").addClass("dark");
}

var cookieMedium = getCookie('mediumSize');
if (cookieMedium === 'null'
    || cookieMedium === ""
    || cookieMedium === null
    || cookieMedium === undefined
    || cookieMedium === 'undefined') {
  $("body").removeClass("mediumSize");
}
else {
  $("body").addClass("mediumSize");
}

var cookieBig = getCookie('bigSize');
if (cookieBig === 'null'
    || cookieBig === ""
    || cookieBig === null
    || cookieBig === undefined
    || cookieBig === 'undefined') {
  $("body").removeClass("bigSize");
}
else {
  $("body").addClass("bigSize");
}

$(document).ready(function () {



  // color cookies

  $('#color p').each(function(){

    $(this).click(function(){

      var cookClass = $(this).attr('id');

      switch(cookClass) {

        case "dark":

          eraseCookie('lightCook');

          createCookie("darkCook",1,12);

          return false;

          break;

        case "light":

          eraseCookie('darkCook');

          createCookie("lightCook",1,12);

          return false;

          break;

        default:

          eraseCookie('lightCook');

          eraseCookie('darkCook');

          return false;

      }


    });

  });

  //fontCookies

  $('#fontSize p').each(function(){

    $(this).click(function(){

      var cookClass = $(this).attr('id');

      switch(cookClass) {

        case "mediumSize":

          eraseCookie('bigSize');

          createCookie("mediumSize",1,12);

          return false;

          break;

        case "bigSize":

          eraseCookie('mediumSize');

          createCookie("bigSize",1,12);

          return false;

          break;

        default:

          eraseCookie('mediumSize');

          eraseCookie('bigSize');



          return false;

      }
    });

  });
  // page color

  $('#color p').each(function(){

    $(this).click(function(){

      $('body').removeClass('normal').removeClass('dark').removeClass('light').addClass($(this).attr('id'));

      return false;

    });

  });

  // fontSize

  $('#fontSize p').each(function(){

    $(this).click(function(){

      $('body').removeClass('smallSize').removeClass('mediumSize').removeClass('bigSize').addClass($(this).attr('id'));

      return false;

    });

  });



  $('.modules__inner.owl-carousel').owlCarousel({
    items: 1,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000,
    mouseDrag: true,
    margin: 25,
    responsive: {
      1024: {
        items: 5
      }
    }
  });


  $('[data-front-slider]').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    speed: 1000,
    fade: true,
    useTransform: true,
    // cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
    adaptiveHeight: true,
    appendArrows: $('.sliderHome__nav'),
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>'
  });

  // lazyload
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // var wow = new WOW();
  // wow.init();

  var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || ms.scrollTop) >= 100) {
      header.classList.add('short');
    } else {
      header.classList.remove('short');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });

  if (document.querySelector('.rellax')) {
    var rellax = new Rellax('.rellax', {
      center: true
    });
  }

  $(".sliderOwl__arrowDown").on("click", function (e) {
    e.preventDefault();
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.intro').offset().top - 100
    }, 1500, 'swing');
  });


	var hash= window.location.hash

	// if ( hash == '' || hash == '#' || hash == undefined ) return false;


	      var target = $(hash);

				// console.log(target);

	      headerHeight = 120;
	      // target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				// console.log(hash);

				if (target.length) {
	        $('html,body').stop().animate({
	          scrollTop: target.offset().top - 125 //offsets for fixed header
	        }, 'linear');
	      }

});
$(document).ready(function() {
  $(window).scroll(function(){
    if($(window).scrollTop() > 45 ) {
      $("header").addClass('fixed');
    } else {
      $("header").removeClass('fixed');
    }
  });
  inView('.js-animate')
  .on('enter', el => {
      $(el).addClass("css-animate");
  });
  $(".header__mobile_menu, .close_menu").click(function () {
    $(".mobileMenu").toggleClass("active");
  });
  $(window).scroll(function(){
    if($(window).scrollTop() > 300 ) {
      $(".arrow-top").addClass('active');
    } else {
      $(".arrow-top").removeClass('active');
    }
  });
  $(".arrow-top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
  $(".message__info").click(function(){
    $(".message__info").css("display", "none");
  });
  var owl = $('.banner__wrapper');
  owl.owlCarousel({
    loop: true,
    margin: 0,
    animateIn: 'fadeInDown',
    animateOut: 'fadeOutDown',
    dots: true,
    items: 1,
    mouseDrag: false,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 7000,
    onRefreshed:function(el){
      $('.banner__wrapper').find(".banner__item-text_top").removeClass("css-animation");
      $('.banner__wrapper').find(".banner__item-text_bottom").removeClass("css-animation");
      $('.banner__wrapper').find(".owl-item.active").find(".banner__item-text_top").addClass("css-animation");
      $('.banner__wrapper').find(".owl-item.active").find(".banner__item-text_bottom").addClass("css-animation");
      $('.banner__wrapper').find(".banner__item").removeClass("banner-animation");
      $('.banner__wrapper').find(".owl-item.active").find(".banner__item").addClass("banner-animation");
    },
    onInitialized:function(el){
    },
    onChanged:function(el){
      setTimeout(function() {
        $('.banner__item').addClass("banner-animation");
        $('.banner__wrapper').find(".banner__item-text_top").removeClass("css-animation");
        $('.banner__wrapper').find(".banner__item-text_bottom").removeClass("css-animation");
        $('.banner__wrapper').find(".owl-item.active").find(".banner__item-text_top").addClass("css-animation");
        $('.banner__wrapper').find(".owl-item.active").find(".banner__item-text_bottom").addClass("css-animation");
      }, 1000);
    }
  });
  $('.banner__nav_prev').click(function(){
    owl.trigger('prev.owl.carousel');
  });
  $('.banner__nav_next').click(function(){
      owl.trigger('next.owl.carousel');
  });



});

function scroll(e) {

  var href = $(this).attr('href');

  e.preventDefault();

  $('html, body').animate({
    scrollTop: $(href).offset().top - 150
  }, 1500);

  location.hash = href;

};


$('a[href*="#"]').click(scroll);

